import React from "react";

const StatCard = ({ title, value, icon, color = "bg-white", textColor = "text-gray-800" }) => (
  <div className={`stat shadow rounded-lg ${color}`}>
    {icon && (
      <div className={`stat-figure text-2xl ${textColor}`}>
        <i className={`fa-solid ${icon}`}></i>
      </div>
    )}
    <div className="stat-title text-xs">{title}</div>
    <div className={`stat-value text-lg ${textColor}`}>{value ?? "—"}</div>
  </div>
);

export default StatCard;
